module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAASCAYAAABvqT8MAAAAAXNSR0IArs4c6QAAAJJJREFUKBWdkrENgDAQAxEFLRswA2zBIBklmzADLUJCYhQWoKQIZ4mC7g2W3N0l/JOq+pNSykx32lk+4EaVgw6hBNTShSonHR2pAZxkkIumUBIAmGU8ya6UEHSLolubUAQaqeZRNF/rSAOgNqesEurQcgFO9D8J2B8a2FsroP/jgL89DYT34+vDxSB8e97hiS/gBqYL7zpiticsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/id_arrow_white.png
// module id = jwxk
// module chunks = 27